import Swiper from "swiper";

const selectors = {
  faq: "[data-faq]",
  accordion: "[data-accordion]",
};

const initAccordions = (container) => {
  const accordions = container.querySelectorAll(selectors.accordion);

  accordions.forEach((accordion) =>
    accordion.addEventListener("click", () =>
      accordion.dataset.accordion === "active"
        ? accordion.setAttribute("data-accordion", "")
        : accordion.setAttribute("data-accordion", "active")
    )
  );
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const containers = document.querySelectorAll(selectors.faq);

    containers?.forEach(initAccordions);
  },
  {
    once: true,
  }
);
